module.exports = __webpack_public_path__ + "img/craneRearLeft.e777cc5c.svg";